export const GetFormPrice = (inputs, components = {}) => {
    const flowFormInputs = inputs !== null && inputs !== void 0 ? inputs : {};
    let componentFormTotalPrice = 0;
    for (const id in flowFormInputs) {
        const formInput = flowFormInputs[id];
        const component = components[id];
        if (formInput && component) {
            switch (component.type) {
                case "chooser-with-conditional-visibility-input":
                case "chooser":
                    const currentOption = component.options.find((option) => formInput.value === option.name);
                    if (currentOption && currentOption.price > 0) {
                        componentFormTotalPrice += currentOption.price;
                    }
                    break;
                default:
                    break;
            }
        }
    }
    return componentFormTotalPrice;
};
